import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from '@eds-web/react';
import { selectAlertMessages } from '../../selectors/common.selector';
import { AlertType } from '../../types/common.types';

export const AlertContainer: React.FC = () => {
    const messages = useSelector(selectAlertMessages);
    const dispatch = useDispatch();
    const snackbar = useSnackbar();

    useEffect(() => {
        if (messages.length > 0) {
            const latestMessage = messages[messages.length - 1];

            // Show snackbar based on type
            switch (latestMessage.type) {
                case AlertType.SUCCESS:
                    snackbar.success({
                        message: latestMessage.message,
                        duration: latestMessage.duration
                    });
                    break;
                case AlertType.CRITICAL:
                    snackbar.critical({
                        message: latestMessage.message,
                        duration: latestMessage.duration
                    });
                    break;
                case AlertType.WARNING:
                    snackbar.warning({
                        message: latestMessage.message,
                        duration: latestMessage.duration
                    });
                    break;
                case AlertType.NEUTRAL:
                default:
                    snackbar.neutral({
                        message: latestMessage.message,
                        duration: latestMessage.duration
                    });
                    break;
            }
        }
    }, [messages, dispatch, snackbar]);

    return null;
};
